import { IPatientWaitingListFiltersParamsBody } from "@/api_framework/api_modals/Patients";
import { IPatientWaitingListState } from "@/app_redux/reducers/slices/auth/patient_waiting_list_slice";
import useRouteInfo from "../../useRouteInfo";
import { useRouter } from "../../useRouter";
import { usePatientWaitingListAPI } from "../PWL/usePatientWaitingListAPI";

const useRefetchPWL = () => {
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("PATIENT_WAITING_LIST", "id"));
  const { filters: PWLFilters } = routeState.state as IPatientWaitingListState;
  const fetchPWL = usePatientWaitingListAPI();

  const execute = async (overrides?: Pick<IPatientWaitingListFiltersParamsBody, "page" | "limit">) => {
    if (Object.keys(PWLFilters ?? {})?.length > 0) {
      await fetchPWL(overrides ? { ...PWLFilters, ...overrides } : PWLFilters);
    }
  };
  return execute;
};

export default useRefetchPWL;
